import React from "react";
import ICTHHeader from "../ICTHHeader/ICTHHeader";
import { IMenuHeaderProps } from "../IHeader";

const MenuHeader = ({
  onChangeLanguage,
  language,
  showSwitchLanguage,
  menus,
  content,
}: IMenuHeaderProps): JSX.Element => {
  return (
    <ICTHHeader
      content={content}
      onChangeLanguage={onChangeLanguage}
      language={language}
      showSwitchLanguage={showSwitchLanguage}
      menus={menus}
      showMenus
    />
  );
};

export default MenuHeader;
